module.exports = __webpack_public_path__ + "assets/img/services6.4db8a97b.svg";